<template>
    <div>
        <div class="type-btn" :class="{'type-btn-small': $vuetify.breakpoint.xs}">
            <v-btn-toggle 
                v-model="mapType" 
                mandatory 
                rounded 
                dense 
                borderless
                active-class="type-selected"
            >
                <v-btn small value="roadmap">
                    Mapa vial
                </v-btn>
                <v-btn small value="hybrid">
                    Satelital
                </v-btn>
            </v-btn-toggle>
        </div>
        <GmapMap
            ref="map"
            v-if="profile"
            :center="{
                lat: profile.location.latitude,
                lng: profile.location.longitude,
            }"
            :zoom="profile.map_zoom"
            :options="{
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
            }"
            :map-type-id="mapType"
            class="map"
        >
            <div v-if="records && plants">
                <div :key="plant.id" v-for="plant in plants">
                    <GmapMarker
                        v-if="plant.location"
                        :position="{
                            lat: plant.location.latitude,
                            lng: plant.location.longitude,
                        }"
                        :icon="getIcon(plant.id)"
                        :ref="plant.id"
                        :clickable="true"
                        @click="updateSelected(plant.id)"
                    />
                </div>
            </div>
            
        </GmapMap>
        <div class="h-100 pt-sm-16 pt-md-0" v-if="selected" style="z-index: 1000">
            <v-row >
                <v-col cols="12" offset-md="8" md="4">
                    <v-row class="h-100">
                        <v-btn fab color="primary" x-small @click="updateSelected(null)" class="close mt-12 mt-md-0">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-col class="h-100 pt-sm-10 pt-md-0">
                            <infoMeter 
                                :gateway="plants.find(p => p.id == selected)" 
                                :meters="getMeters(selected)" 
                                :lastReadings="getLastReadings(selected)"
                                />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <div class="license">
            <a href="https://mapicons.mapsmarker.com/" >
                <img src="@/assets/map/license.gif" alt="license"  />
            </a>
        </div>
        
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { Readings } from '../api'
import infoMeter from '../components/Plants/info'

export default {
    name: 'MapView',
    computed: {
        ...mapState({
            selected: state => state.gateways.selected,
            profile: (state) => state.account.profile,
            plants: (state) => state.gateways.list,
            records: (state) => state.meters.lastReadings
        }),
        ...mapGetters({ getMeters: 'meters/getMetersGtw' })
    },
    components: { infoMeter },
    data() {
        return {
            mapType: 'satellite'
        }
    },
    methods: {
        ...mapActions({ 
            updatedView: 'user/updatedView',
            updateSelected: 'gateways/updatedGatewaySelected'
        }),
        getIcon(plant) {
            let icon = {}
            let metersRecords = this.getLastReadings(plant)
            let plant_data = this.plants.find( p => p.id === plant )
            let type = this.profile.rates.find( r => r.name === plant_data.rate ).type

            if( plant == this.selected ) icon.scaledSize = { width: 41, height: 48 }
            if( metersRecords.length === 0 ){
                icon.url =  require(`@/assets/map/${type}-gray.png`)
                return icon
            } 

            let lastRecord = metersRecords
                .reduce((last, read) => 
                    last.timestamp == null || new Date(read.timestamp).getTime() > new Date(last.timestamp).getTime() 
                        ? read 
                        : last 
                    , { timestamp: null })
            
            if (lastRecord) {
                let time = new Date().getTime() - new Date(lastRecord.timestamp).getTime()
                let watts = lastRecord.lines.reduce((total, line) => total + line.watts, 0)

                if( (this.profile.minutesToDanger * 60 * 1000) < time ) 
                    icon.url = require(`@/assets/map/${type}-red.png`) 

                else if( (this.profile.minutesToWarn * 60 * 1000) < time ) 
                    icon.url = require(`@/assets/map/${type}-yellow.png`) 

                else if( watts > this.profile.limitOff ) 
                    icon.url = require(`@/assets/map/${type}-green.png`) 
                
                else icon.url = require(`@/assets/map/${type}-white.png`) 
            }else{
                icon.url = require(`@/assets/map/${type}-gray.png`) 
            }
            
            return icon
        },
        getLastReadings(plant){
            let meters = this.getMeters(plant).map( m => m.name )
            return this.records.filter( r => meters.includes(r.meter) )
        },
        setCenter(){
            if(this.selected){
                let location = this.plants.find( p => p.id === this.selected ).location
                this.$refs.map.panTo({
                    lat: location.latitude,
                    lng: location.longitude + 0.01,
                })
            }
        }
    },
    watch: {
        selected(){
            this.setCenter()
        }
    },
    mounted(){
        this.updatedView('Map')
        this.setCenter()
    }
}
</script>

<style scoped>
.h-100{
    height: 100%;
}
.map {
    display: contents;
}
.back{
    position: absolute;
    top: 10px;
    left: 10px;
}
.license {
    position: absolute;
    bottom: 19px;
    z-index: 2;
}
.type-btn{
    position: absolute;
    top: 10px;
    z-index: 2;
}
.type-btn-small{
    top: 60px !important;
}
.v-btn:before{
    opacity: 0 !important;
}
.type-selected{
    color: var(--v-accent-base) !important;
    background-color: white !important;
}
.close{
    position: absolute;
    right: 1px;
    top: 10px;
    z-index: 2;
}
</style>
